import { Link, NavLink } from "react-router-dom";
import { useState } from "react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/domains", label: "Domains" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/institutions", label: "Institutions" },
  { to: "/pricing", label: "Pricing" },
  { to: "/sample-report", label: "Sample Report" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="nav-glass sticky top-0 z-40" data-testid="navbar">
      <div className="container-msis flex items-center justify-between py-4">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <div className="w-9 h-9 bg-navy text-white flex items-center justify-center font-display font-bold text-sm tracking-tighter">M</div>
          <div className="flex flex-col leading-tight">
            <span className="font-display font-bold text-base tracking-tight">MSIS</span>
            <span className="text-[10px] tracking-[0.15em] uppercase text-slate2">Inclination Scale</span>
          </div>
        </Link>
        <nav className="hidden lg:flex items-center gap-6">
          {NAV.map((n) => (
            <NavLink
              key={n.to} to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, '-')}`}
              className={({ isActive }) =>
                `text-sm transition-colors hover:text-navy ${isActive ? "text-navy font-medium" : "text-slate2"}`
              }
            >{n.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/login" className="text-sm text-slate2 hover:text-navy hidden md:inline" data-testid="login-link">Login</Link>
          <Link to="/take-test" className="btn-primary !py-2 !px-4 text-sm" data-testid="nav-take-test">Take Test</Link>
          <button
            className="lg:hidden p-2 border border-border rounded-md"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-white">
          <div className="container-msis py-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
                className="py-2 text-sm text-slate2 hover:text-navy"
                data-testid={`mnav-${n.label.toLowerCase().replace(/\s/g, '-')}`}
              >{n.label}</NavLink>
            ))}
            <Link to="/login" onClick={() => setOpen(false)} className="py-2 text-sm text-slate2">Login</Link>
          </div>
        </div>
      )}
    </header>
  );
}
